import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { DefaultAppBar } from "../layouts/Header/DefaultAppBar";
import AppFooter from "../layouts/AppFooter";
import { Container, Stack, Typography } from "@mui/material";
import { ReactComponent as LostNavigation } from '@inspectify/design/assets/images/general/LostNavigation.svg';
import { LayoutProvider } from "../layouts/useLayoutContext";

function RootBoundary() {
  const error = useRouteError();
  let message = '';
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      message = "This page doesn't exist!";
    }

    if (error.status === 401) {
      message = "You aren't authorized to see this";
    }

    if (error.status === 503) {
      message = "Looks like our API is down";
    }

    if (error.status === 418) {
      message = "🫖";
    }
  }

  return (
    <LayoutProvider>
      <DefaultAppBar />
      <Container>
        <Stack spacing={2} alignItems="center" py={4}>
          <LostNavigation />
          <Stack spacing={2} alignItems="center">
            <Typography variant="h1">Please refresh the page and try again.</Typography>
            <Typography variant="h3" mt={2}>If the issue persists, please contact support.</Typography>
            <Typography variant="body1">{message}</Typography>
          </Stack>
        </Stack>
      </Container>
      <AppFooter />
    </LayoutProvider>
  )
}

export default RootBoundary;
